
// Widget Scripts
import swiperWidgetMainFeature from './js/widgets/swiperWidgetMainFeature';
import cardWidgetSecondFeature from './js/widgets/cardWidgetSecondFeature';
import cardWidgetSeoFeature from './js/widgets/cardWidgetSeoFeature';
import multiScheduleFeature from './js/widgets/multiScheduleFeature';


// Custom Theme Scripts
import './js/localjs.js';
import './js/subpagethemejs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {

    swiperWidgetMainFeature()
    cardWidgetSecondFeature()
    cardWidgetSeoFeature()
    multiScheduleFeature()

  });

}



